import loader from '../../common/loader';
import cookie from '../../common/cookie';
import { loginCookie } from '../login/common';
var jsApi = 'https://yybfrontend.cdn-go.cn/yyb-common-offline/latest/jsbridge/jsbridge.min.js';
var qqAppid = '1101070898';
var wxAppid = 'wx3909f6add1206543';
var miloSelfConfig = {
  isMiloWayCookies: false,
  appName: 'yyb'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve, reject) {
    if (window.JsBridge) {
      resolve(window.JsBridge);
      return;
    }

    loader.loadScript(jsApi).then(function (isLoad) {
      if (isLoad && window.JsBridge) {
        resolve(window.JsBridge);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.login(function () {
      location.reload();
    }, 'DEFAULT');
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.login(function () {
      location.reload();
    }, 'WX');
  })["catch"](function () {});
};

var loginByQQ = function loginByQQ() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.login(function () {
      location.reload();
    }, 'MOBILEQ');
  })["catch"](function () {});
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve, reject) {
    loadJsApi().then(function (JsBridge) {
      JsBridge.call('getUserLoginToken', {}, function (res) {
        if (res && res.data) {
          console.log('getUserLoginToken返回', res.data);

          var _ref = JSON.parse(res.data) || {},
              logintype = _ref.logintype,
              wopenid = _ref.wopenid,
              waccesstoken = _ref.waccesstoken,
              qskey = _ref.qskey,
              quin = _ref.quin,
              mobileqopenid = _ref.mobileqopenid,
              mobileqtoken = _ref.mobileqtoken; // 清空渠道侧脏数据干扰


          loginCookie.clearQQ();

          if (logintype === 'MOBILEQ' && quin && qskey) {
            loginCookie.setQQ({
              uin: quin,
              skey: qskey
            }, 7200);
          } else if (logintype === 'MOBILEQ' && mobileqopenid && mobileqtoken) {
            window.iUseQQConnect = 1;
            loginCookie.setLocal({
              acctype: 'qc',
              appid: qqAppid,
              openid: mobileqopenid,
              access_token: mobileqtoken
            }, 7200);
          } else if (logintype === 'WX' || logintype === 'wx') {
            console.log('before setCookie');
            console.log('appid', wxAppid);
            console.log('openid', wopenid);
            console.log('access_token', waccesstoken);
            loginCookie.setQQ({
              acctype: 'wx',
              appid: wxAppid,
              openid: wopenid,
              access_token: waccesstoken
            }, 7200);
          }

          resolve();
        } else {
          reject();
        }
      });
    })["catch"](function () {
      reject();
    });
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    var logintype = cookie.get('logintype');

    if (logintype === 'WX') {
      resolve('wx');
    }

    if (logintype === 'MOBILEQ' && cookie.get('mobileqaccesstoken') && cookie.get('mobileqopenid')) {
      resolve('qc');
    }

    if (logintype === 'MOBILEQ') {
      resolve('pt');
    }

    resolve(null);
  });
};

var logout = function logout() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.logout();
  })["catch"](function () {});
};

var yyb = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default yyb;